import React, { Component } from "react";
import Prismic from 'prismic-javascript';
import { PrismicConfig } from "../../config";

const defaultState = {
	prismicContext : null,
	terms: null
};

const PrismicContext = React.createContext(defaultState);

class PrismicProvider extends Component {
	
	
	state = defaultState
	
	_refs = {};
	
	componentDidMount() {
		this.buildContext().then((prismicContext) => {
			
			this.setState({ prismicContext });	
			this.getTerms();
			this.getMenu();

		}).catch((e) => {
			console.error(`Cannot contact the API, check your prismic configuration:\n${e}`);
		});
	};
	
	buildContext() {
		const accessToken = PrismicConfig.accessToken;
		return Prismic.api(PrismicConfig.apiEndpoint, { accessToken }).then(api => ({
			api,
			endpoint: PrismicConfig.apiEndpoint,
			accessToken,
			linkResolver: PrismicConfig.linkResolver,
			toolbar: this.refreshToolbar,
		})
	)};
	
	getTerms = async () => {
		const terms = await this.state.prismicContext.api.getSingle('terms');
		this.setState({
			terms: terms.data
		  });
	};
	
	getHomepage = (lang) => {
    let language = 'en-au';

    if (lang) {
      switch (lang) {
        case 'mx': language = 'es-mx';
          break;
      }
    }
		this.state.prismicContext.api.getSingle('homepage', { lang: language }).then((homepage) => {
			this.setState({
				homepage: homepage
			});
		});
	};

	getMenu = (lang) => {
      let language = 'en-au';

      if (lang) {
         switch (lang) {
            case 'mx': language = 'es-mx';
               break;
         }
      }
		this.state.prismicContext.api.getSingle('menu', { lang: language }).then((menu) => {
			this.setState({
				menu: menu
			});
		});
	};
	
	getPage = (uid, lang) => {
    let language = 'en-au';

    if (lang) {
			switch (lang) {
				case 'mx': language = 'es-mx';
					break;
			}
    }

    this.state.prismicContext.api.getByUID('page',uid, { lang: language }).then((content) => {
			if(content) {
				// console.log('getPage loaded',content);
				this.setState({content:content, error:false});
			}else {
				console.error('getPage error',content);
				this.setState({error:true});
			}
			
		});
	};

	getPageData = (uid) => {
		return this.state.prismicContext.api.getByUID('page',uid)
	};
	
	render() {
		const { children } = this.props;
		const context = {
			...this.state,
			prismic: {
				getTerms: this.getTerms,
				getHomepage: this.getHomepage,
				getPage: this.getPage,
				getPageData: this.getPageData,
				getMenu: this.getMenu
			}
		};
		return (
			<PrismicContext.Provider value={context}>
			{children}
			</PrismicContext.Provider>
		);
	};
}

const withPrismic = WrappedComponent => {
	return function PrismicConnectedComponent(props) {
		return (
			<PrismicContext.Consumer>
			{data => <WrappedComponent {...props} {...data} />}
			</PrismicContext.Consumer>
		);
	};
};

export default PrismicProvider;
export { withPrismic };



// WEBPACK FOOTER //
// ./src/components/Prismic/Prismic.js